import { render, staticRenderFns } from "./PhoenixStepProgress.vue?vue&type=template&id=068e5055"
import script from "./PhoenixStepProgress.vue?vue&type=script&lang=js"
export * from "./PhoenixStepProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports